import * as $ from 'jquery';
import 'bootstrap';
import 'slick'

export class partnersSection {
	private partnersBody: any   = $('#partners');
  private isAnimationCompleted: any = false;
  private ResponsiveView: any = [
    {breakpoint: 1024, slide: 3, min: 919},
    {breakpoint: 919, slide: 2, min: 768},
    {breakpoint: 768, slide: 1, min: 600},
    {breakpoint: 600, slide: 1, min: 480},
    {breakpoint: 480, slide: 1, min: 0},
  ]
  initializaCarousel() {
    let self = this;
    let totalPartners = parseInt($('.partners-carousel').attr('data-totalSlides'));
    let progressSlide = null;
    let breakPoint: any = null;
    // initialize the slick carousel
    $('.partners-carousel').on('init', function(event: any, slick: any) {
      breakPoint = parseInt(self.calculateViewPort(self));
      if(totalPartners % breakPoint === 0) {
        progressSlide = totalPartners / breakPoint;
      } else {
        let i = totalPartners / breakPoint;
        progressSlide = Math.floor(i) + 1;
      }
      $('.progress-bar').html('');
      $('.progress-bar').css('width', progressSlide * 5 + '%');
      for(let i = 0; i < progressSlide; i++) {
        $('.progress-bar').append('<div class="slide slide-' + i + '"></div>');
        $('.slide').css('width', 100/progressSlide + '%');
        if(i !== 0) {
          let ml = (100/progressSlide) * i;
          $('.slide-' + i).css('margin-left', ml+'%');
        }
      }
      let sChild = $('.slide');
      $(sChild[0]).addClass('active');
    });
    // define options
    $('.partners-carousel').slick({
      dots: false,
      infinite: false,
      speed: 400,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false
          }
        },
        {
          breakpoint: 919,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false
          }
        }
      ]
    });
    // set carousel when slide changes.
    $('.partners-carousel').on('afterChange', function(event: any, slick: any, currentSlide: any) {
      let sChild = $('.slide');
      $.each(sChild, function( index:any , value: any ) {
        $(sChild[index]).removeClass('active');
      });
      if(currentSlide === 0) {
        $(sChild[0]).addClass('active');
      } else {
        let prgressActive = currentSlide / breakPoint;
        $(sChild[prgressActive]).addClass('active');
      }
    });
  }
  initializaBackground() {
    let bgPattern = document.getElementById('partners');
    let self = this;
    function isElementInView() {
      const rect = bgPattern.getBoundingClientRect();
      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)

      );
    }
    window.addEventListener("scroll", function() {
      let isInView = isElementInView();
      if(isInView && !self.isAnimationCompleted) {
        $('.moving-image').addClass('bounce-in-top');
        self.isAnimationCompleted = true;
      }
      if(self.isAnimationCompleted) {
        setTimeout(() => {
          $('.moving-image').removeClass('bounce-in-top');
          $('.moving-image').addClass('grow');
        }, 5000);
      }
    });
  }
  calculateViewPort(self: any): any {
    let visualViewport = window.visualViewport;
    let breakPoint = null;
    for(let i = 0; i < self.ResponsiveView.length; i ++) {
      if(visualViewport.width >= self.ResponsiveView[i].breakpoint) {
        breakPoint = self.ResponsiveView[i].slide;
        break;
      } else if (visualViewport.width < self.ResponsiveView[i].breakpoint && visualViewport.width >= self.ResponsiveView[i].min) {
        breakPoint = self.ResponsiveView[i].slide;
        break;
      } else if(visualViewport.width === self.ResponsiveView[i].breakpoint) {
        breakPoint = self.ResponsiveView[i].slide;
        break;
      }
    }
    return breakPoint;
  }
}

let scope:Element = document.querySelector('#partners');
if (scope) {
	try {
		let partner = new partnersSection();
    partner.initializaBackground();
    partner.initializaCarousel();
	} catch(e) {console.error(e);}
}